import styled, { css, FlattenSimpleInterpolation } from "styled-components";
import { devices } from "../../styles/Breakpoints";

export const TipsContainer = styled.div`
  margin-bottom: 20px;

  .cards,
  .bullet-cards {
    display: flex !important;
    width: fit-content !important;
    background: ${({ theme }) => theme.colors.white};

    height: 138px;
    margin: 0 7px;
    border: 1px solid #28f0b4;
    box-shadow: 0px 0px 8.53px rgba(0, 0, 0, 0.15);
    border-radius: 8px;
  }
  .cards {
    align-items: center;
  }
  .cards > p {
    font-size: 10px;
    line-height: 13px;
    max-width: 190px;
    margin: 0 15px;
    color: #000000;
  }
  .bullet-cards {
    flex-direction: column;
    justify-content: center;
  }
  .bullet-cards > ul {
    font-size: 14px;
    list-style: inside;
    margin: 0 15px;
  }
  .bullet-cards > li {
    font-size: 10px;
    line-height: 13px;
  }
  #text-header {
    font-size: 10px;
    margin: 0 15px;
    font-weight: 700;
    /* font-size: 14px; */
  }
  .continue {
    margin: 5px auto 0;
    background-color: ${({ theme }) => theme.colors.nrmaSeaFoam};
    color: ${({ theme }) => theme.colors.nrmaBlue};
    border-radius: 2px;
    height: 48px;
    width: 230px;
    border: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    font-size: 13px;
  }
  .continue > img {
    margin-left: 18px;
  }
  #tips-header {
    color: ${({ theme }) => theme.colors.nrmaBlue};
    font-size: 18px;
    margin-bottom: 19px;
    font-weight: 400;
    line-height: 18px;
    text-align: center;
  }
  .button__bar {
    text-align: center;
    margin: 5px 0 0px;
    /* margin: 20px 0; */
  }

  .button__bar li {
    list-style: none;
    cursor: pointer;
    display: inline-block;
    margin: 0 3px;
    padding: 0;
  }

  .button__bar li button {
    border: none;
    background: #8f8f8f;
    color: transparent;
    cursor: pointer;
    display: block;
    height: 10px;
    width: 10px;
    border-radius: 10px;
    padding: 0;
  }

  .button__bar li.slick-active button {
    background-color: #000e82;
  }

  .custom-right-arrow {
    position: absolute;
    right: calc(4% + 1px);
    z-index: 1;
    /* opacity: 0.8; */
    background-color: white;
    cursor: pointer;
    top: 40%;
    width: 20px;
    height: 20px;
    transform: translate(0, -50%);
  }
  .custom-right-arrow:hover {
    opacity: 1;
  }
  .custom-left-arrow {
    position: absolute;
    left: 0px;
    z-index: 1;
    /* opacity: 0.8; */
    cursor: pointer;
    top: 40%;
    width: 20px;
    height: 20px;
    transform: translate(0, -50%);
    background-color: white;
  }
  .custom-left-arrow {
    opacity: 1;
  }
  .center {
    justify-content: center;
  }
  margin-bottom: 40px;
  & > p {
    font-weight: 500;
    line-height: 40px;
  }

  .tips-button {
    display: flex;
    margin-top: 5%;
  }
  .tips-button > div {
    width: 100%;
  }
  #slider-info {
    text-align: center;
    color: #131228;
    margin-top: -7px;
  }
  .tips-button > button {
    display: flex;
    background: #ffffff;
    border-radius: 40px;
    width: 40px;
    height: 40px;
    border: none;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }

  @media ${devices.tablet} {
    .cards,
    .bullet-cards {
      height: 200px;
      margin: 0 22px;
      /* margin-right: 20px; */
    }
    .cards > p {
      font-size: 14px;
      line-height: 16.8px;
      max-width: 235px;
    }
    #text-header {
      font-size: 16px;
      margin: 0 15px;
      max-width: 400px;
    }
    .bullet-cards > ul {
      list-style: inside;
      margin: 0 15px;
      line-height: 16.8px;
    }
    #tips-header {
      line-height: normal;
      font-size: 36px;
      margin-bottom: 30px;
    }
  }
  @media only screen and (min-width: 600px) and (max-width: 663px) {
    .cards > p {
      max-width: 210px;
    }
    #text-header {
      max-width: 203px;
    }
  }
  @media ${devices.tabletLandscape} {
    .cards,
    .bullet-cards {
      height: 200px;
      margin: 0 22px;
      /* margin-right: 20px; */
    }
    .cards > p {
      font-size: 14px;
      line-height: 16.8px;
      max-width: 400px;
    }
    #text-header {
      font-size: 16px;
      margin: 0 15px;
    }
    .bullet-cards > ul {
      list-style: inside;
      margin: 0 15px;
      line-height: 16.8px;
    }

    #tips-header {
      font-size: 36px;
      margin-bottom: 30px;
    }
  }
  @media only screen and (min-width: 891px) and (max-width: 922px) {
    .cards > p {
      max-width: 380px;
    }
  }
  @media ${devices.laptopL} {
    .cards,
    .bullet-cards {
      height: 139px;
      /* margin-right: 22px; */
      margin: 0 22px;
    }
    #text-header {
      margin: 0 15px;
    }
    .bullet-cards > ul {
      list-style: inside;
      margin: 0 15px;
      line-height: 16.8px;
    }
    .cards > p {
      font-size: 14px;
      max-width: 432px;
      line-height: 16.8px;
    }

    #tips-header {
      font-size: 36px;
      font-weight: 400;
      margin-bottom: 30px;
    }
  }
`;
